import React, { useRef, useEffect } from "react";
import "./index.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "gatsby";
import ReactHtmlParser from "react-html-parser";

import DealCard from "../Cards/DealCard";
import DealsFaqSection from "../DealsFaqSection";
import DetailsDetailSection from "../DealsDetailsSection";
import Disclaimer from "../Disclaimer";
import AnnoucementBarHempBan from "../AnnoucementBarHempBan";

const DealCategoryContents = ({ categories, activeCategory, deals, sortedDeals, allDealsCategoryImage }) => {
  // console.log("===>  categories", categories);
  // console.log("===> Active Category", JSON.stringify(activeCategory));
  // console.log("===> Deals", deals);
  // console.log("===> All Category Image", allDealsCategoryImage);

  const noDeals = activeCategory?.dealCategoryContent?.noDeals;
 let customDeals = sortedDeals;

// unsorted remaining deals 
const sortedIds = new Set(sortedDeals?.map((deal) => deal.id));
const remainingDeals = deals?.filter((deal) => !sortedIds.has(deal.id));

customDeals = [...customDeals, ...remainingDeals];

  const [showAll, setShowAll] = React.useState(false);
  const visibleDeals = showAll ? customDeals : customDeals?.slice(0, 6);
  const hasMoreDeals = customDeals?.length > 6;

  return (
    <div className="deals-category-content">
      <AnnoucementBarHempBan />
      <Disclaimer type="brands" />
      <div className="deals-banner">
        <a
          className="deals-banner-link"
          href={activeCategory?.dealCategoryContent?.banner?.link}
        >
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={
                activeCategory?.dealCategoryContent?.banner?.mobileBannerImage
                  ?.sourceUrl
              }
            />
            <img
              className="deals-banner-img"
              src={
                activeCategory?.dealCategoryContent?.banner?.mainBannerImage
                  ?.sourceUrl
              }
              alt={
                activeCategory?.dealCategoryContent?.banner?.mainBannerImage
                  ?.altText
              }
            />
          </picture>
        </a>
      </div>

      <h2 className="deals-category-heading">Shop by category</h2>
      <div className="deals-category-links">
        {(() => {
          const PrevArrow = ({ className, style, onClick }) => (
            <button
              type="button"
              className={`${className} custom-arrow prev-arrow`}
              style={{ ...style }}
              onClick={onClick}
              aria-label="Previous"
            >
              <svg
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M-1.10629e-07 15.6839C-1.71725e-07 24.3454 7.31131 31.3678 16.3294 31.3678C25.3474 31.3678 32.6587 24.3454 32.6587 15.6839C32.6587 7.0223 25.3474 0 16.3294 0C7.31131 0 -4.95332e-08 7.0223 -1.10629e-07 15.6839ZM16.6944 8.79504C16.8116 8.90662 16.9047 9.03928 16.9684 9.18543C17.0322 9.33158 17.0653 9.48836 17.066 9.64682C17.0666 9.80527 17.0348 9.9623 16.9722 10.1089C16.9097 10.2556 16.8177 10.3889 16.7015 10.5014L12.594 14.4774L23.0809 14.4774C23.4141 14.4774 23.7336 14.6045 23.9691 14.8308C24.2047 15.057 24.337 15.3639 24.337 15.6839C24.337 16.0038 24.2047 16.3107 23.9691 16.537C23.7336 16.7632 23.4141 16.8903 23.0809 16.8903L12.594 16.8903L16.7015 20.8663C16.8177 20.9789 16.9096 21.1124 16.9721 21.2591C17.0346 21.4058 17.0664 21.5629 17.0657 21.7215C17.0649 21.88 17.0317 22.0368 16.9679 22.183C16.904 22.3292 16.8109 22.4619 16.6936 22.5735C16.5764 22.6851 16.4375 22.7734 16.2847 22.8334C16.1319 22.8934 15.9684 22.924 15.8033 22.9233C15.6383 22.9226 15.475 22.8906 15.3228 22.8293C15.1706 22.768 15.0324 22.6785 14.9162 22.5659L8.68361 16.5337C8.45014 16.3077 8.31912 16.0022 8.31912 15.6839C8.31912 15.3655 8.45014 15.0601 8.68361 14.8341L14.9162 8.80182C15.0325 8.68909 15.1707 8.59948 15.323 8.53811C15.4753 8.47675 15.6387 8.44484 15.8039 8.44421C15.969 8.44358 16.1327 8.47424 16.2855 8.53444C16.4383 8.59464 16.5773 8.68319 16.6944 8.79504Z"
                  fill="#313131"
                />
              </svg>
            </button>
          );

          const NextArrow = ({ className, style, onClick }) => (
            <button
              type="button"
              className={`${className} custom-arrow next-arrow`}
              style={{ ...style }}
              onClick={onClick}
              aria-label="Next"
            >
              <svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32.6587 16.011C32.6587 7.16882 25.3474 6.42231e-05 16.3293 6.34501e-05C7.31129 6.26771e-05 -2.83016e-05 7.16881 -2.909e-05 16.011C-2.98784e-05 24.8532 7.31128 32.022 16.3293 32.022C25.3474 32.022 32.6587 24.8532 32.6587 16.011ZM15.9643 23.0435C15.8471 22.9296 15.754 22.7942 15.6903 22.645C15.6265 22.4958 15.5934 22.3357 15.5927 22.174C15.5921 22.0122 15.6239 21.8519 15.6865 21.7022C15.749 21.5525 15.841 21.4164 15.9572 21.3016L20.0647 17.2426L9.57777 17.2426C9.24463 17.2426 8.92513 17.1129 8.68957 16.8819C8.454 16.6509 8.32166 16.3377 8.32166 16.011C8.32166 15.6844 8.454 15.3711 8.68957 15.1401C8.92513 14.9092 9.24463 14.7794 9.57777 14.7794L20.0647 14.7794L15.9572 10.7205C15.841 10.6055 15.7491 10.4693 15.6866 10.3195C15.6241 10.1697 15.5923 10.0093 15.593 9.84752C15.5938 9.68569 15.627 9.52558 15.6908 9.37635C15.7547 9.22711 15.8478 9.09167 15.9651 8.97774C16.0823 8.86382 16.2212 8.77365 16.374 8.71238C16.5268 8.65111 16.6903 8.61995 16.8554 8.62066C17.0204 8.62137 17.1837 8.65396 17.3359 8.71655C17.4881 8.77914 17.6263 8.87051 17.7424 8.98544L23.9751 15.1435C24.2086 15.3742 24.3396 15.686 24.3396 16.011C24.3396 16.336 24.2086 16.6478 23.9751 16.8785L17.7424 23.0366C17.6262 23.1517 17.488 23.2432 17.3357 23.3058C17.1834 23.3684 17.02 23.401 16.8548 23.4017C16.6897 23.4023 16.526 23.371 16.3732 23.3095C16.2204 23.2481 16.0814 23.1577 15.9643 23.0435Z"
                  fill="#313131"
                />
              </svg>
            </button>
          );

          const sliderRef = useRef(null);

          const settings = {
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            gap: 20,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
            responsive: [
              { breakpoint: 1200, settings: { slidesToShow: 4 } },
              { breakpoint: 992, settings: { slidesToShow: 3 } }
              // { breakpoint: 480, settings: { slidesToShow: 2 } }
            ]
          };

          const filteredCategories = (categories || [])
            .filter(category => category !== null)
            .sort((a, b) => {
              const aName = (a?.name || "").trim();
              const bName = (b?.name || "").trim();
              const aFirst = aName.charAt(0).toLowerCase();
              const bFirst = bName.charAt(0).toLowerCase();

              // Sort by first character first, then by full name for stable ordering.
              return aFirst.localeCompare(bFirst) || aName.localeCompare(bName);
            });

          // add the default all category option at the beginning of the categories array
          const allDealsCategory = {
            name: "All Deals",
            slug: "all",
            id: "all-deals",
            dealCategoryContent: {
              categoryImage: { sourceUrl: allDealsCategoryImage?.sourceUrl, altText: "All Deals" }
            }
          };

          const customcategories = [allDealsCategory, ...filteredCategories];

          // Find the index of the currently active category so we can scroll
          // the slider to make it visible on initial render.
          const activeIndex = customcategories.findIndex(
            cat => cat.slug === activeCategory?.slug || cat.id === activeCategory?.id
          );

          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (sliderRef.current && activeIndex > 0) {
              // slickGoTo(index, dontAnimate) — pass true to skip the animation
              // on first load so the slider jumps straight to the right position.
              sliderRef.current.slickGoTo(activeIndex, true);
            }
          }, [activeIndex]);

          return (
            <Slider ref={sliderRef} {...settings}>
              {customcategories?.map(category => (
                <div key={category.slug}>
                  <Link
                    key={category.slug || category.id}
                    to={category?.slug == "all" ? "/deals" : `/deals/${category.slug}`}
                    className={`deal-link${
                      (activeCategory?.slug
                        ? category.slug === activeCategory.slug
                        : category.slug === "all")
                        ? " deal-link--active"
                        : ""
                    }`}
                  >
                    <img
                      className="deal-category-image"
                      src={
                        category?.dealCategoryContent?.categoryImage?.sourceUrl
                      }
                      alt={
                        category?.dealCategoryContent?.categoryImage?.altText
                      }
                    />
                    <span>{category.name}</span>
                  </Link>
                </div>
              ))}
            </Slider>
          );
        })()}
      </div>

      {activeCategory?.dealCategoryContent?.categorySubtext && (
        <div className="deals-subtext-1">
          <div className="deals-subtext-contents">
            {ReactHtmlParser(
              activeCategory?.dealCategoryContent?.categorySubtext
            )}
          </div>
        </div>
      )}

      {customDeals?.length > 0 && noDeals !== true ? (
        <>
          <h2 className="deals-category-heading">Deals of the month</h2>
          <div className="deals-grid">
            {visibleDeals?.map(deal => {
              // console.log("===> Deal: ", deal);
              return (
                <div key={deal.id} className="deals-grid-item">
                  <DealCard deal={deal} />
                </div>
              );
            })}
          </div>

          {!showAll && hasMoreDeals && (
            <div className="deals-show-all-container">
              <button
                className="deals-show-all-btn"
                onClick={() => setShowAll(true)}
              >
                SHOW ALL
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="deals-nothing-found">
          <h2>Nothing Found</h2>
          <p>
            Seems like there’s no deals currently for this category. Check other
            categories to see what deals are ready for you. Don’t miss out!
          </p>
        </div>
      )}

      {activeCategory?.dealCategoryContent?.categorySubtext2 && (
        <div className="deals-subtext-2">
          {ReactHtmlParser(
            activeCategory?.dealCategoryContent?.categorySubtext2
          )}
        </div>
      )}
      {activeCategory?.dealCategoryContent?.faqs && (
        <DealsFaqSection faqData={activeCategory?.dealCategoryContent?.faqs} />
      )}

      {activeCategory?.dealCategoryContent?.details && (
        <DetailsDetailSection
          detailsData={activeCategory?.dealCategoryContent?.details}
        />
      )}
    </div>
  );
};

export default DealCategoryContents;
